export let BusinessRegistrationStatus;
(function (BusinessRegistrationStatus) {
  BusinessRegistrationStatus["Registered"] = "registered";
  BusinessRegistrationStatus["NotRegistered"] = "not-registered";
})(BusinessRegistrationStatus || (BusinessRegistrationStatus = {}));